<template>
    <div>
        <div class="register-wrapper">
            <div id="register">
                <p class="title">学员登录</p>
                <el-form
                    :model="ruleForm"
                    status-icon
                    :rules="rules2"
                    ref="ruleForm"
                    label-width="0"
                    class="demo-ruleForm"
                >
                    <el-form-item prop="username">
                        <el-input
                            v-model="ruleForm.username"
                            auto-complete="off"
                            placeholder="请输入用户名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                        <el-input
                            type="password"
                            v-model="ruleForm.password"
                            auto-complete="off"
                            placeholder="输入密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button
                            type="primary"
                            @click="doLogin('ruleForm')"
                            style="width:100%;"
                        >登录</el-button>
                        <p class="login" @click="gotoRegister" v-if="flag">没有账号，去注册</p>
                        <a :href="forgetPassword()" target="_blank">
                            <p class="forget" v-if="flag">忘记密码</p>
                        </a>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
// import { nextTick } from 'q'
// import axios from "axios";
import { mapMutations } from 'vuex'
export default {
    name: 'StudentLogin',
    data() {
        return {
            ruleForm: {
                password: '',
                username: ''
            },
            rules2: {
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ],
                username: [
                    { required: true, message: '请输入账号', trigger: 'blur' }
                ]
            },
            flag: localStorage.getItem('allowRegister'),
            activeName: 'login'
        }
    },
    methods: {
        // <!--提交登录-->
        doLogin() {
            let data = {
                username: this.ruleForm.username,
                password: this.ruleForm.password,
                platformId: localStorage.getItem('datas')
            }
            var qs = require('qs')
            this.$axios
                .post(
                    this.$managePath + '/offline/api/studentLogin',
                    qs.stringify(data),
                    {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    }
                )
                .then(res => {
                    if (res.data.status == 0) {
                        this.$alert(res.data.errorDesc, {
                            confirmButtonText: '确定',
                            callback: action => {
                                this.$message({
                                    type: 'info',
                                    message: res.data.errorDesc
                                })
                            }
                        })
                    } else {
                        this.token = res.data.data
                        this.changeLogin(this.token)
                        this.$router.push('/study')
                    }
                })
                .catch(res => {
                    console.log('err')
                })
        },
        focusToError() {
            setTimeout(() => {
                this.errorStepPage('active0', 0)
                this.errorStepPage('active1', 1)
                this.errorStepPage('active2', 2)
            }, 1)
            return false
        },
        // 初始化校验不通过跳转情况
        errorStepPage: function(activeClassName, page) {
            var errorStep = document.getElementsByClassName(activeClassName)
            var Error = errorStep[0].getElementsByClassName('is-error')
            if (Error.length > 0) {
                this.active = page
                if (Error[0].querySelector('textarea') != null) {
                    Error[0].querySelector('textarea').focus()
                } else {
                    Error[0].querySelector('input').focus()
                }
                return
            }
        },
        // },
        // <!--进入注册页-->
        gotoRegister() {
            this.$router.push({
                path: '/student/register'
            })
        },
        // 修改密码
        forgetPassword() {
            return (
                this.$studentPath +
                '/user/toRetrievePassword?platformId=' +
                localStorage.getItem('datas')
            )
        }
    }
}
</script>

<style scoped>
.loading-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: #aedff8;
    display: flex;
    align-items: center;
    justify-content: center;
}
.register-wrapper img {
    position: absolute;
    z-index: 1;
}
.register-wrapper {
    position: fixed;
    top: 20%;
    right: 0;
    left: 0;
    bottom: 0;
}
#register {
    max-width: 340px;
    margin: 60px auto;
    background: #fff;
    padding: 20px 40px;
    border-radius: 10px;
    position: relative;
    z-index: 9;
}
.title {
    font-size: 16px;
    line-height: 50px;
    font-weight: bold;
    margin: 10px;
    text-align: center;
}
.el-form-item {
    text-align: center;
}
.login,
.forget {
    margin-top: 10px;
    font-size: 14px;
    line-height: 22px;
    color: #1ab2ff;
    cursor: pointer;
    text-align: left;
    text-indent: 8px;
    display: inline-block;
}
.login {
    float: left;
}
.forget {
    float: right;
}
.login:hover {
    color: #2c2fd6;
}
.code >>> .el-form-item__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.code button {
    margin-left: 20px;
    width: 140px;
    text-align: center;
}
.el-button--primary:focus {
    background: #409eff;
    border-color: #409eff;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/student/StudentLogin.vue